/* eslint-disable prefer-rest-params */
export const ERROR = {
  NAME_EMPTY: '名前を入力してください。',
  NAME_LENGTH: '名前は20文字以内で入力してください。',
  EMAIL_EMPTY: 'メールアドレスを入力してください。',
  EMAIL_PATTERN: '正しいメールアドレスを入力してください。',
  EMAIL_CONFIRM: 'メールアドレスが正しくありません',
  PASSWORD_EMPTY: 'パスワードを入力してください。',
  PASSWORD_PATTERN: 'パスワードは英数字と記号を含む8文字以上で入力してください。',
  PASSWORD_CONFIRM: 'パスワードが一致していません。',
  QUESTIONNARIE_TITLE_EMPTY: 'アンケートタイトルを入力してください。',
  QUESTIONNARIE_TITLE_LENGTH: 'アンケートタイトルは20文字以内で入力してください。',
  QUESTIONNARIE_SUMMARY_EMPTY: '説明文を入力してください。',
  QUESTIONNARIE_SUMMARY_LENGTH: '説明文は50文字以内で入力してください。',
  QUESTIONNARIE_EMPTY: '質問を入力してください。',
  QUESTIONNARIE_LENGTH: '質問は20文字以内で入力してください。',
  QUESTIONNARIE_OPTION_EMPTY: '選択肢を入力してください。',
  QUESTIONNARIE_OPTION_LENGTH: '選択肢は20文字以内で入力してください。',
  DESCRIPTION_EMPTY: '説明文を入力してください。',
  DESCRIPTION_LENGTH: '説明文は500文字以内で入力してください。',
  IMAGE_EMPTY: 'コーチ画像を入力してください。',
  LOGO_IMAGE_EMPTY: 'ロゴ画像を追加してください。',
  PLAYGROUND_EMPTY: 'コート名を入力してください。',
  PLAYGROUND_LENGTH: 'コート名は20文字以内で入力してください。',
  PLAYGROUND_DESCRIPTION_EMPTY: '説明文を入力してください。',
  PLAYGROUND_DESCRIPTION_LENGTH: '説明文は50文字以内で入力してください。',
  PLAYGROUND_LIMIT_EMPTY: '対応人数を入力してください。',
  PLAYGROUND_LIMIT_LENGTH: 'コート名は20文字以内で入力してください。',
  PLAYGROUND_IMAGE_EMPTY: 'コート画像を入力してください。',
  LESSON_EMPTY: 'レッスン名を入力してください。',
  LESSON_LENGTH: 'レッスン名を20文字以内で入力してください。',
  LESSON_DESCRIPTION_LENGTH: '説明文は50文字以内で入力してください。',
  LESSON_IMAGE_EMPTY: 'レッスン画像を入力してください。',
  LESSON_LEVEL_EMPTY: 'レベルを選択してください。',
  SCHOOL_NAME_EMPTY: 'スクール名を入力してください。',
  SCHOOL_NAME_LENGTH: 'スクール名を50文字以内で入力してください。',
  SCHOOL_DESCRIPTION_LENGTH: '説明文は200文字以内で入力してください。',
  SCHOOL_LOGO_EMPTY: 'ロゴ画像を追加してください。',
  SCHOOL_ADDRESS_EMPTY: '住所を入力してください。',
  SCHOOL_TEL_EMPTY: '電話番号を入力してください。',
  SCHOOL_IMAGE_EMPTY: 'スクール画像を追加してください。',
  SCHOOL_LEBEL_NAME_EMPTY: 'レベル名を入力してください。',
  SCHOOL_LEBEL_DESCRIPTION_EMPTY: 'レベル説明を入力してください。',
  SCHOOL_ALERT_EMPTY: 'アラート内容を入力してください。',
  SCHOOL_ALERT_LENGTH: 'アラート内容は100文字以内で入力してください。',
  SCHOOL_ALERT_URL_EMPTY: 'リンク先を入力してください。',
  LEVEL_NAME_EMPTY: 'レベル名を入力してください。',
  LEVEL_NAME_LENGTH: 'レベル名は20文字以内で入力してください。',
  LEVEL_DESCRIPTION_EMPTY: 'レベル説明を入力してください。',
  LEVEL_DESCRIPTION_LENGTH: 'レベル説明は50文字以内で入力してください。',
  SCHEDULE_DATE_START_EMPTY: '日程を選択してください。',
  SCHEDULE_REPEAT_OPTION: '間隔を選択してください。',
  SCHEDULE_REPEAT_END_DATE_EMPTY: '繰り返し終了日を選択してください。',
  SCHEDULE_MAX_PEOPLE_EMPTY: 'レッスン上限人数を入力してください。',
  HOME_RESERVATION_NAME_EMPTY: '予約者氏名を入力してください。',
  HOME_RESERVATION_TEL_EMPTY: '電話番号を入力してください。',
  HOME_RESERVATION_NOTE_LENGTH: '備考は500文字以内で入力してください。',
  EMPTY: '{0}を入力してください。',
  PATTERN: '正しい{0}を入力してください。',
  LENGTH: '{0}を{1}文字以内で入力してください。',
  MIN_MAX: '範囲内の人数を設定してください。',
  NAME_LAST_EMPTY: '姓を入力してください。',
  NAME_FIRST_EMPTY: '名を入力してください。',
  NAME_LAST_KANA_EMPTY: 'セイを入力してください。',
  NAME_FIRST_KANA_EMPTY: 'メイを入力してください。',
  NAME_LAST_LENGTH: '姓は30文字以内で入力くしてください。',
  NAME_FIRST_LENGTH: '名は30文字以内で入力してください。',
  NAME_LAST_KANA_LENGTH: 'セイは50文字以内で入力してください。',
  NAME_FIRST_KANA_LENGTH: 'メイは50文字以内で入力してください。',
  NAME_PATTERN: '全角、半角、英文字を入力してください。',
  NAME_LAST_KANA_PATTERN: 'セイはカタカナで入力してください。',
  NAME_FIRST_KANA_PATTERN: 'メイはカタカナで入力してください。',
  TERMS_EMPTY: '利用規約・プライバシーポリシーへ同意してください。',
  PHONE_EMPTY: '電話番号を入力してください。',
  PHONE_PATTERN: '正しい電話番号を入力してください。',
  TEL_PATTERN: '正しい電話番号を入力してください。',
  PASSWORD_INVALID: '現在のパスワードが正しくありません',
  OLD_PASSWORD_EMPTY: '現在のパスワードを入力してください。',
  NEW_PASSWORD_EMPTY: '新しいパスワードを入力してください。',
  EMPTY_GENERAL: 'この項目は必須です。',
  CREDIT_CARD: 'カード番号が無効です。',
  NAME_KANA: 'カタカナで入力してください。',
  NAME_HAFT_KANA: '半角カタカナで入力してください。',
  COURT_EMPTY: 'コート名を入力してください。',
  COURT_LENGTH: 'コート名は20文字以内で入力してください。',
  COURT_TYPE_EMPTY: '説明文を入力してください。',
  COURT_TYPE_LENGTH: '説明文は50文字以内で入力してください。',
  COURT_LIMIT_EMPTY: '対応人数を入力してください。',
  COURT_LIMIT_LENGTH: 'コート名は20文字以内で入力してください。',
  COURT_IMAGE_EMPTY: 'コート画像を入力してください。',
  BIRTHDAY_EMPTY: '生年月日を入力してください。',
  TIME: '開始時間は終了時間より大きくなければなりません。',
};

export const PATTERN = {
  NAME: /^[^!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+$/i,
  EMAIL: /^\S+@\S+\.\S+$/i,
  PRICE: /^[0-9]{1,12}\.{0,1}[0-9]{0,2}$/i,
  MAX_PEOPLE: /^[1-2]{0,1}[0-9]{1}$/i,
  PASSWORD:
    /^((?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])|(?=.*[a-z])(?=.*[A-Z])(?=.*[!\"#$%&'()*+,-./:;<=>?@^_`{|}~\[\]])|(?=.*[A-Z])(?=.*[0-9])(?=.*[!\"#$%&'()*+,-./:;<=>?@^_`{|}~\[\]])|(?=.*[a-z])(?=.*[0-9])(?=.*[!\"#$%&'()*+,-./:;<=>?@^_`{|}~\[\]]))([a-zA-Z0-9!\"#$%&'()*+,-./:;<=>?@^_`{|}~\[\]]){8,}$/,
  NAME_KANA: /^[ァ-ヶ　０-９]+$/i, // カタカナのみ（ヵ、ヶ含む）
  NAME_KANA_HAFT_WIDTH: /^[ｧ-ﾝﾞﾟ]+$/,
  TEL: /^[0-9-]{1,30}$/i,
  NUMBER: /^\d+$/,
};

export const SIZE = {
  MAX_IMAGE_NUMBER: '5',
  MAX_IMAGE_UPLOAD: '10MB',
  MAX_IMAGE_UPLOAD_SETTING: '2MB',
};
export const EASE = {
  OUT: [0.23, 1.0, 0.32, 1.0],
};

// レッスン、イベントを分別するため
export const TYPE = {
  LESSON: 1,
  EVENT: 2,
};

export const QR_CODE_TYPE = {
  MY_QR_CODE: 1,
  LESSON_QR_CODE: 2,
};

// 繰り返しタイプ
export const REPEAT_TYPE = {
  NONE: 0, // 選択してください
  WEEKLY: 1, // 毎週
  MONTHLY: 2, // 毎月
  YEARLY: 3, // 毎年
};

// プランタイプ
export const PLAN_TYPE = {
  NORMAL_PLAN: 1, // 1: 通常プラン
  HOLIDAY_PLAN: 0, // 0: 休会プラン
};

// 振替チケット付与タイミングの設定
export const TRANSFER_TICKET_TIMING = {
  AUTOMATIC: 1, // 1: 自動（発生対象のプラン・チケットでの欠席時）
  MANUAL: 2, // 2: 手動
};

// 期限設定の種類
export const DUE_DATE_SETTING_TYPE = {
  NO_LIMIT: 0, // 無期限
  PERIOD: 1, //期間指定
  DATE: 2, // 日付を指定
  TRANSFER_PERIOD: 3,
  SPECIFY_PERIOD_END_DATE: 4, //期末日を指定
  SPECIFY_NEXT_PERIOD_END_DATE: 5, //翌期の末日を指定
};

// 利用開始日
export const DUE_DATE_SETTING_TYPE_START = {
  CANCELLATION_DATE: 1, // キャンセル日
  FIRST_DAY_OF_TERM: 2, // 期の初日
  THE_RELEVANT_LESSON_DATE: 3, // 当該レッスン日
};

/**
 *
 * @param mess
 * @param param
 * @returns full message
 */
export const getMessage = (mess: string, ...param: any[]) => {
  if (param.length === 0) {
    return mess;
  }
  const args = param;
  return mess.replace(/\{(\d+)\}/g, function () {
    return args[arguments[1]] || `${arguments[1]}`;
  });
};

export const TICKET_TYPE = {
  MONTHLY: 0,
  SET: 1,
  RETURN: 2,
  FREE: 3,
};

/**
 * "1: undecided（出席予定）
    2: present（出席）
    3: absent（無断欠席）
    4: cancelled（欠席）
    "
 */
export const RESERVE_EVENT_DATE_STATUS = {
  UNDECIDED: 1,
  PRESENT: 2,
  ABSENT: 3,
  CANCELLED: 4,
};

/**
 * "0: 未対応（ waiting）
    1: 対応中（inprogress）
    2: 対応済み（completed）
    3: キャンセル（cancelled）
    "
 */
export const RESERVE_STATUS = {
  WAITING: 0,
  INPROGRESS: 1,
  COMPLETED: 2,
  CANCELLED: 3,
};

/**
 * "
  1: hold （開催）
  2: cancel（中止）
  "
 */
export const EVENT_DATE_STATUS = {
  HOLD: 1,
  CANCEL: 2,
};

/**
 * "0: 差額なし
    1: 未払い
    2: 受領済み
    "
 */
export const PRICE_DIFFERENCE_STATUS = {
  DEFAULT: 0,
  UNPAID: 1,
  PAID: 2,
};

export const TICKET_STATUS = {
  UNUSED: 1,
  INUSE: 2,
  USED: 3,
};

// チケット タイプ
export const SCHOOL_TICKET_TYPE = {
  REGULAR: 0, // 定期チケット
  NUMBER: 1, // 回数チケット
  TRANSFER: 2, // 振替チケット
  FREE: 3, // フリーチケット
};

/**
 * "1: チケットで予約 (ticket)
    2: プランで予約 (plan)
    3: 代理予約（現金払い） (admin)
    4: 代理予約（チケット使用） (admin)
    "
 */
export const RESERVE_METHOD = {
  TICKET: 1,
  PLAN: 2,
  ADMIN_CASH: 3,
  ADMIN_TICKET: 4,
  EVENT_WINDOW: 5,
  EVENT_CARD: 6,
};
/**
0: 処理中
1: 成功
2: 失敗
4：キャンセル
*/
export const PAYMENT_STATUS = {
  INPROGRESS: 0,
  COMPLETED: 1,
  FAIL: 2,
  CANCELLED: 3,
  SCHEDULED: 4,
  NOPAY: 5,
  FIXED_AMOUNT: 6,
  CASH_RECEIVED: 7,
};

export const TRANSFER_STATUS_TEXT = {
  [PAYMENT_STATUS.INPROGRESS]: '処理中',
  [PAYMENT_STATUS.COMPLETED]: '成功',
  [PAYMENT_STATUS.FAIL]: '失敗',
  [PAYMENT_STATUS.CANCELLED]: 'キャンセル',
  [PAYMENT_STATUS.SCHEDULED]: '金額未確定',
  [PAYMENT_STATUS.NOPAY]: '請求なし',
  [PAYMENT_STATUS.FIXED_AMOUNT]: '金額確定',
  [PAYMENT_STATUS.CASH_RECEIVED]: '受領済',
};

export const enum TABLE_NAME {
  TICKET = 'TICKET',
  EVENT = 'EVENT',
  PLAN = 'PLAN',
}

export const MONTHLY_TICKET_TYPE = 0;

export const SET_TICKET_TYPE = 1;

export const RETURN_TICKET_TYPE = 2;

export const FREE_TICKET_TYPE = 3;

export const PLAN_PAYMENT_METHOD = {
  BANK_ACCOUNT_TRANSFER: 1,
  CREDIT_CARD: 2,
  GROUP_TOTAL: 3,
  ZENGIN_DATA: 4,
  CASH: 5,
};

export const ZENGIN_EXPORT_TYPE = {
  I_NET: 1,
  WIDE_NET: 2,
};

export const MONTHLY_PAYMENT_PLAN_STATUS = {
  NONE: 0,
  ESTIMATED: 1,
  CALCULATED: 2,
  FIXED: 3,
  GMO_SENDED: 4,
};

export const DATE_CHECK_GMO = {
  DAY_05: 18,
  DAY_23: 9,
};

/**
 * "0: 差額なし
    1: 未払い
    2: 受領済み
    "
 */
export const TICKET_FEE_STATUS = {
  DEFAULT: 0,
  UNPAID: 1,
  PAID: 2,
};

export const ROLE_VALUE = {
  ADMIN: 1,
  PARTNER: 2,
  STAFF: 3,
  TOURNAMENT_STAFF: 4,
};

export const ROLE_NAME = {
  ADMIN: '管理者',
  PARTNER: 'パートナー',
  STAFF: 'スタッフ',
  TOURNAMENT_STAFF: '大会スタッフ',
};

export const URL_ALLOW = [
  '/[schoolSlug]/login',
  '/[schoolSlug]/email_recover',
  '/[schoolSlug]/email_recover_invalid',
  '/[schoolSlug]/password_reset',
  '/[schoolSlug]/password_reset_invalid',
  '/[schoolSlug]/password_reset_success',
];

export const TEMPLATE_MAIL_ID = {
  COMPLETION_WITHDRAWAL: 'spohabi-mail-001', //【スポハビ】退会の手続き完了のお知らせ
  CHANGE_MAIL: 'spohabi-mail-002', //【スポハビ】メールアドレス変更完了のお知らせ
  VERIFY_MAIL: 'spohabi-mail-003', //【スポハビ】メールアドレスのご本人様確認
  RGISTRATION_MEMBER: 'spohabi-mail-004', //【スポハビ】本会員登録完了のお知らせ
  EMAIL_ADDRESS_VERIFICATION: 'spohabi-mail-005', //【スポハビ】メールアドレスの認証
  CHANGE_PASS: 'spohabi-mail-006', //【スポハビ】パスワード変更完了のお知らせ
  RESERVATION_CANCEL: 'spohabi-mail-007', //【スポハビ】ご予約キャンセルのお知らせ
  RESERVATION_CHANGE: 'spohabi-mail-008', //【スポハビ】ご予約変更のお知らせ
  NOTICE_DAY_BEFORE_RESERVATION: 'spohabi-mail-009', //【スポハビ】ご予約の前日のお知らせ
  RESERVATION_COMPLETION: 'spohabi-mail-010', //【スポハビ】ご予約の完了のお知らせ
  RESER_PASS: 'spohabi-mail-011', //【スポハビ】パスワードリセットのご確認
  CONFIRM_CHANGE_MAIL: 'spohabi-mail-012', //【スポハビ】メールアドレス変更のご確認
  NOTICE_VACANT_SEAT: 'spohabi-mail-013', //【スポハビ】ご希望のレッスンへ空席が出ました。
  PURCHASE_TICKET_COMPLETION: 'spohabi-mail-014', //【スポハビ】チケット購入完了のお知らせ
  CANCELLATION_RESERVATION_LESSON: 'spohabi-mail-015', //【スポハビ】ご予約のレッスン中止のお知らせ
  NOTICE_RESERVATION_LESSON: 'spohabi-mail-016', //【スポハビ】ご予約のレッスン開催のお知らせ
  NOTICE_TOURNAMENT_SCHEDULE_UPDATE: 'spohabi-mail-018', //【スポハビ】大会スケジュール更新のお知らせ
  MEMBER_INVITATION: 'spohabi-mail-022', //【スポハビ】{{スクール名}}への招待が届いています
  CANCEL_TOURNAMENT: 'spohabi-mail-023', // 【【スポハビ】大会申込のキャンセルのお知らせ
  NOTICE_OF_APPLICATION_COMPLETION: 'spohabi-mail-024', // 【スポハビ】お申し込み完了のお知らせ
  NOTICE_OF_APPLICATION_UPDATE: 'spohabi-mail-025', // 【スポハビ】大会スケジュール更新のお知らせ
  PAIR_STATUS_UPDATE_NOTICE: 'spohabi-mail-026', // 【スポハビ】大会スケジュール更新のお知らせ
  ADMIN_CANCEL_TOURNAMENT: 'spohabi-mail-027', // 【スポハビ】お申し込みのキャンセルのお知らせ
  ADMIN_SEND_TOURNAMENT_INVITATION: 'spohabi-mail-028', // 【スポハビ】お申し込みのキャンセルのお知らせ
};

/**
0: 解約
1: 契約中
2: 休会中
 */
export const SCHOOL_MEMBER_STATUS = {
  CANCELLED: 0,
  PLAN: 1,
  AJOURNEMENT: 2,
};

export const BANK_ACCOUNT_TYPE = {
  PERSONAL: '1',
  ENTERPRISE: '2',
};

export const TOURNAMENT_TYPE = {
  SINGLE: 1,
  DOUBLES: 2,
};

export const BANK_ACCOUNT_TRANSACTION_STATUS = {
  SUCCESS: 'SUCCESS',
  ENTRY: 'ENTRY',
  START: 'START',
  TERM: 'TERM',
  FAIL: 'FAIL',
  UNPROCESSED: 'UNPROCESSED',
};

export const SEMESTER_TYPE = {
  REPEAT_EVERY_YEAR: 1,
  SET_INDIVIDUALLY: 2,
};

export const MONTHLY_PAYMENT_METHOD = {
  BASE_ON_PLAN: 1,
  BASE_ON_LESSON: 2,
};

export const SELECTION_CRITERIA = {
  FIRST_COME: 1,
  LOTTERY: 2,
};

export const TOURNAMENT_SETTING_TYPE = {
  // 参加要項
  REQUIREMENT: 1,
  //申込締切
  ADMISSION_DEADLINE: 2,
  // 結果発表日
  RESULT_ANNOUNCEMENT: 3,
  // 手続き締切
  PROCEDURE_DEADLINE: 4,
  // 注意事項
  NOTE: 5,
};

export const SELECTION_STATUS = {
  UNDER_SELECTION: 1,
  PARTICIPANT: 2,
  CANCEL: 3,
  NOT_PARTICIPANT: 4,
  TEMPORARY_REGISTRATION: 5,
  STATUS_ALT: 6,
  SELECTED_NOT_PAID: 7,
};
/**
 * "1: undecided（出席予定）
    2: present（出席）
    3: absent（無断欠席）
    4: cancelled（欠席）
    "
 */
export const PLAYER_ATTENDANCE_STATUS = {
  UNDECIDED: 1,
  PRESENT: 2,
  ABSENT: 3,
  CANCELLED: 4,
};

export const TOURNAMENT_PAYMENT_STATUS = {
  UNPAID: 1,
  RECEIVED: 2,
  CANCEL: 3,
};

export const TOURNAMENT_PAYMENT_STATUS_NAME = {
  [TOURNAMENT_PAYMENT_STATUS.UNPAID]: '未払い',
  [TOURNAMENT_PAYMENT_STATUS.RECEIVED]: '受領済み',
  [TOURNAMENT_PAYMENT_STATUS.CANCEL]: 'キャンセル',
};

export const TOURNAMENT_PARTNER_INVITES = {
  INVITE_SEND: 1,
  ACCPECT: 2,
  CANCEL: 3,
};

export const SELECTION_STATUS_OPTION = [
  {
    value: 1,
    label: '出席予定',
  },
  {
    value: 2,
    label: '出席',
  },
  {
    value: 3,
    label: '無断欠席',
  },
  {
    value: 4,
    label: '欠席',
  },
];

export const TOURNAMENT_PAYMENT_METHOD = {
  CREDIT_CARD: 2,
  CASH: 1,
  NONE: 3,
};

export const TOURNAMENT_PAYMENT_METHOD_NAME = {
  [TOURNAMENT_PAYMENT_METHOD.CREDIT_CARD]: 'クレジットカード',
  [TOURNAMENT_PAYMENT_METHOD.CASH]: '現金',
  [TOURNAMENT_PAYMENT_METHOD.NONE]: 'なし',
};

export const CAN_NOT_ADD_TOURNAMENT_SLUG = ['school-slug'];

export const TOURNAMENT_GAME_TYPE = {
  MATCH: 1,
  EVENT: 2,
  MATCH_TEMP: 3,
};

export const TOURNAMENT_GROUP_TYPE = {
  KNOCKOUT: 1,
  LEAGUE: 2,
};

export const SCORE_TYPE = {
  SINGLE_SET: 1,
  MULTI_SET: 2,
};

export const TOURNAMENT_GAME_STATUS = {
  MATCH_BEFORE: 1,
  MATCH_IN_PROGRESS: 2,
  MATCH_END: 3,
  MATCH_STOP: 4,
};

export const SELECT_GAME_STATUS = [
  {
    label: '正常終了',
    value: 1,
  },
  {
    label: 'RET',
    value: 2,
  },
  {
    label: 'NO-SHOW',
    value: 3,
  },
  {
    label: 'W.O',
    value: 4,
  },
  {
    label: 'Not Played',
    value: 5,
  },
  {
    label: 'DEF',
    value: 6,
  },
];

export const SCHEDULE_DATA_TYPE = [
  {
    label: 'コート別',
    value: 1,
  },
  {
    label: '対戦表別',
    value: 2,
  },
  {
    label: 'オーダーオブプレイ',
    value: 3,
  },
];

// 5-5になった場合の試合ルール
export const SCORE_REACHES_RULE = {
  NEXT_GAME_ENDS: 1, // 5-5になった場合、6-5になったらゲーム終了
  TWO_GAME_WIN: 2, // 5-5、6-6,5-6,6-5になった場合、7-5、7-6になったらゲーム終了(6-5)
};

export const BEST_OF_SETS_FORMAT = 5;
export const MAX_GAMES_IN_SET = 6;
export const TOURNAMENT_GAME_GAME_STATUS = {
  NORMAL: 1,
  RET: 2,
  NO_SHOW: 3,
  W_O: 4,
  NOT_PLAYED: 5,
  DEF: 6,
};

export const TOURNAMENT_GAME_GAME_STATUS_NAME = {
  // [TOURNAMENT_GAME_GAME_STATUS.NORMAL]: ,
  [TOURNAMENT_GAME_GAME_STATUS.RET]: 'RET',
  [TOURNAMENT_GAME_GAME_STATUS.NO_SHOW]: 'NO-SHOW',
  [TOURNAMENT_GAME_GAME_STATUS.W_O]: 'W.O',
  [TOURNAMENT_GAME_GAME_STATUS.NOT_PLAYED]: 'Not Played',
  [TOURNAMENT_GAME_GAME_STATUS.DEF]: 'DEF',
};

export const TOURNAMENT_GAME_TYPE_NAME = {
  [TOURNAMENT_GAME_TYPE.MATCH]: 'トーナメント',
  [TOURNAMENT_GAME_TYPE.EVENT]: 'リーグ ',
};

export const TOURNAMENT_ARRAY_NUMBER_OF_GAME = [1, 3, 5];

export const GAME_ACQUISITION_RULES = [
  {
    label: '次のゲームで終了',
    value: 1,
  },
  {
    label: '2ゲーム連取',
    value: 2,
  },
];

export const PLAYER_STATUS_OPTION = [
  {
    label: '-',
    value: 0,
  },
  {
    label: 'DA',
    value: 1,
  },
  {
    label: 'QA',
    value: 5,
  },
  {
    label: 'WC',
    value: 2,
  },
  {
    label: 'QWC',
    value: 6,
  },
  {
    label: 'Q',
    value: 3,
  },
  {
    label: 'A',
    value: 8,
  },
  {
    label: 'OSA',
    value: 7,
  },
  {
    label: 'LL',
    value: 4,
  },
];

export const PLAYER_STATUS = {
  DA: 1,
  WC: 2,
  Q: 3,
  LL: 4,
  A: 8,
  QA: 5,
  QWC: 6,
  OSA: 7,
};

export const PLAYER_STATUS_NOT_DISPLAY = ['DA', 'QA'];

export const PLAYER_STATUS_TEXT: { [key: number]: string } = {
  0: '-',
  1: 'DA',
  2: 'WC',
  3: 'Q',
  4: 'LL',
  5: 'QA',
  6: 'QWC',
  7: 'OSA',
  8: 'A',
};

export const SEED_NUMBER_OPTION = [
  {
    label: '-',
    value: 0,
  },
  {
    label: '1',
    value: 1,
  },
  {
    label: '2',
    value: 2,
  },
  {
    label: '3',
    value: 3,
  },
  {
    label: '4',
    value: 4,
  },
  {
    label: '5',
    value: 5,
  },
  {
    label: '6',
    value: 6,
  },
  {
    label: '7',
    value: 7,
  },
  {
    label: '8',
    value: 8,
  },
  {
    label: '9',
    value: 9,
  },
  {
    label: '10',
    value: 10,
  },
  {
    label: '11',
    value: 11,
  },
  {
    label: '12',
    value: 12,
  },
  {
    label: '13',
    value: 13,
  },
  {
    label: '14',
    value: 14,
  },
  {
    label: '15',
    value: 15,
  },
  {
    label: '16',
    value: 16,
  },
];

export const TOURNAMENT_CATEGORY = {
  NORMAL: 1,
  MULTIPLE_TOURNAMENT: 2,
  SUB_TOURNAMENT: 3,
};

export const OOP_OPTION = {
  STARTING_AT: 1,
  NOT_BEFORE: 2,
  FOLLOWED_BY: 3,
};

export const OOP_OPTION_TEXT = {
  [OOP_OPTION.STARTING_AT]: 'Starting at',
  [OOP_OPTION.NOT_BEFORE]: 'Not Before',
  [OOP_OPTION.FOLLOWED_BY]: 'Followed by',
};

export const OOP_SUB_OPTION = {
  TIME_TBA: 1,
  COURT_TBA: 2,
  AFTER_REST: 3,
};

export const OOP_SUB_OPTION_TEXT = {
  [OOP_SUB_OPTION.TIME_TBA]: 'Time TBA',
  [OOP_SUB_OPTION.COURT_TBA]: 'Court TBA',
  [OOP_SUB_OPTION.AFTER_REST]: 'After Rest',
};
export const JAPANESE_PREFECTURES = [
  {
    iso: '01',
    prefecture_kanji: '北海道',
    prefecture_romaji: 'Hokkaido',
    prefecture_kana: 'ほっかいどう',
  },
  {
    iso: '02',
    prefecture_kanji: '青森県',
    prefecture_romaji: 'Aomori Ken',
    prefecture_kana: 'あおもりけん',
  },
  {
    iso: '03',
    prefecture_kanji: '岩手県',
    prefecture_romaji: 'Iwate Ken',
    prefecture_kana: 'いわてけん',
  },
  {
    iso: '04',
    prefecture_kanji: '宮城県',
    prefecture_romaji: 'Miyagi Ken',
    prefecture_kana: 'みやぎけん',
  },
  {
    iso: '05',
    prefecture_kanji: '秋田県',
    prefecture_romaji: 'Akita Ken',
    prefecture_kana: 'あきたけん',
  },
  {
    iso: '06',
    prefecture_kanji: '山形県',
    prefecture_romaji: 'Yamagata Ken',
    prefecture_kana: 'やまがたけん',
  },
  {
    iso: '07',
    prefecture_kanji: '福島県',
    prefecture_romaji: 'Fukushima Ken',
    prefecture_kana: 'ふくしまけん',
  },
  {
    iso: '08',
    prefecture_kanji: '茨城県',
    prefecture_romaji: 'Ibaraki Ken',
    prefecture_kana: 'いばらきけん',
  },
  {
    iso: '09',
    prefecture_kanji: '栃木県',
    prefecture_romaji: 'Tochigi Ken',
    prefecture_kana: 'とちぎけん',
  },
  {
    iso: '10',
    prefecture_kanji: '群馬県',
    prefecture_romaji: 'Gunma Ken',
    prefecture_kana: 'ぐんまけん',
  },
  {
    iso: '11',
    prefecture_kanji: '埼玉県',
    prefecture_romaji: 'Saitama Ken',
    prefecture_kana: 'さいたまけん',
  },
  {
    iso: '12',
    prefecture_kanji: '千葉県',
    prefecture_romaji: 'Chiba Ken',
    prefecture_kana: 'ちばけん',
  },
  {
    iso: '13',
    prefecture_kanji: '東京都',
    prefecture_romaji: 'Tokyo To',
    prefecture_kana: 'とうきょうと',
  },
  {
    iso: '14',
    prefecture_kanji: '神奈川県',
    prefecture_romaji: 'Kanagawa Ken',
    prefecture_kana: 'かながわけん',
  },
  {
    iso: '15',
    prefecture_kanji: '新潟県',
    prefecture_romaji: 'Niigata Ken',
    prefecture_kana: 'にいがたけん',
  },
  {
    iso: '16',
    prefecture_kanji: '富山県',
    prefecture_romaji: 'Toyama Ken',
    prefecture_kana: 'とやまけん',
  },
  {
    iso: '17',
    prefecture_kanji: '石川県',
    prefecture_romaji: 'Ishikawa Ken',
    prefecture_kana: 'いしかわけん',
  },
  {
    iso: '18',
    prefecture_kanji: '福井県',
    prefecture_romaji: 'Fukui Ken',
    prefecture_kana: 'ふくいけん',
  },
  {
    iso: '19',
    prefecture_kanji: '山梨県',
    prefecture_romaji: 'Yamanashi Ken',
    prefecture_kana: 'やまなしけん',
  },
  {
    iso: '20',
    prefecture_kanji: '長野県',
    prefecture_romaji: 'Nagano Ken',
    prefecture_kana: 'ながのけん',
  },
  {
    iso: '21',
    prefecture_kanji: '岐阜県',
    prefecture_romaji: 'Gifu Ken',
    prefecture_kana: 'ぎふけん',
  },
  {
    iso: '22',
    prefecture_kanji: '静岡県',
    prefecture_romaji: 'Shizuoka Ken',
    prefecture_kana: 'しずおかけん',
  },
  {
    iso: '23',
    prefecture_kanji: '愛知県',
    prefecture_romaji: 'Aichi Ken',
    prefecture_kana: 'あいちけん',
  },
  {
    iso: '24',
    prefecture_kanji: '三重県',
    prefecture_romaji: 'Mie Ken',
    prefecture_kana: 'みえけん',
  },
  {
    iso: '25',
    prefecture_kanji: '滋賀県',
    prefecture_romaji: 'Shiga Ken',
    prefecture_kana: 'しがけん',
  },
  {
    iso: '26',
    prefecture_kanji: '京都府',
    prefecture_romaji: 'Kyoto Fu',
    prefecture_kana: 'きょうとふ',
  },
  {
    iso: '27',
    prefecture_kanji: '大阪府',
    prefecture_romaji: 'Osaka Fu',
    prefecture_kana: 'おおさかふ',
  },
  {
    iso: '28',
    prefecture_kanji: '兵庫県',
    prefecture_romaji: 'Hyōgo Ken',
    prefecture_kana: 'ひょうごけん',
  },
  {
    iso: '29',
    prefecture_kanji: '奈良県',
    prefecture_romaji: 'Nara Ken',
    prefecture_kana: 'ならけん',
  },
  {
    iso: '30',
    prefecture_kanji: '和歌山県',
    prefecture_romaji: 'Wakayama Ken',
    prefecture_kana: 'わかやまけん',
  },
  {
    iso: '31',
    prefecture_kanji: '鳥取県',
    prefecture_romaji: 'Tottori Ken',
    prefecture_kana: 'とっとりけん',
  },
  {
    iso: '32',
    prefecture_kanji: '島根県',
    prefecture_romaji: 'Shimane Ken',
    prefecture_kana: 'しまねけん',
  },
  {
    iso: '33',
    prefecture_kanji: '岡山県',
    prefecture_romaji: 'Okayama Ken',
    prefecture_kana: 'おかやまけん',
  },
  {
    iso: '34',
    prefecture_kanji: '広島県',
    prefecture_romaji: 'Hiroshima Ken',
    prefecture_kana: 'ひろしまけん',
  },
  {
    iso: '35',
    prefecture_kanji: '山口県',
    prefecture_romaji: 'Yamaguchi Ken',
    prefecture_kana: 'やまぐちけん',
  },
  {
    iso: '36',
    prefecture_kanji: '徳島県',
    prefecture_romaji: 'Tokushima Ken',
    prefecture_kana: 'とくしまけん',
  },
  {
    iso: '37',
    prefecture_kanji: '香川県',
    prefecture_romaji: 'Kagawa Ken',
    prefecture_kana: 'かがわけん',
  },
  {
    iso: '38',
    prefecture_kanji: '愛媛県',
    prefecture_romaji: 'Ehime Ken',
    prefecture_kana: 'えひめけん',
  },
  {
    iso: '39',
    prefecture_kanji: '高知県',
    prefecture_romaji: 'Kōchi Ken',
    prefecture_kana: 'こうちけん',
  },
  {
    iso: '40',
    prefecture_kanji: '福岡県',
    prefecture_romaji: 'Fukuoka Ken',
    prefecture_kana: 'ふくおかけん',
  },
  {
    iso: '41',
    prefecture_kanji: '佐賀県',
    prefecture_romaji: 'Saga Ken',
    prefecture_kana: 'さがけん',
  },
  {
    iso: '42',
    prefecture_kanji: '長崎県',
    prefecture_romaji: 'Nagasaki Ken',
    prefecture_kana: 'ながさきけん',
  },
  {
    iso: '43',
    prefecture_kanji: '熊本県',
    prefecture_romaji: 'Kumamoto Ken',
    prefecture_kana: 'くまもとけん',
  },
  {
    iso: '44',
    prefecture_kanji: '大分県',
    prefecture_romaji: 'Ōita Ken',
    prefecture_kana: 'おおいたけん',
  },
  {
    iso: '45',
    prefecture_kanji: '宮崎県',
    prefecture_romaji: 'Miyazaki Ken',
    prefecture_kana: 'みやざきけん',
  },
  {
    iso: '46',
    prefecture_kanji: '鹿児島県',
    prefecture_romaji: 'Kagoshima Ken',
    prefecture_kana: 'かごしまけん',
  },
  {
    iso: '47',
    prefecture_kanji: '沖縄県',
    prefecture_romaji: 'Okinawa Ken',
    prefecture_kana: 'おきなわけん',
  },
];

export const RENTAL_COURT_TYPE = {
  HARD: 1,
  CLAY: 2,
  OMNI: 3,
  GLASS: 4,
  CARPET: 5,
};

export const RENTAL_COURT_TYPE_TEXT = {
  [RENTAL_COURT_TYPE.HARD]: 'ハード',
  [RENTAL_COURT_TYPE.CLAY]: 'グレー',
  [RENTAL_COURT_TYPE.OMNI]: 'オムニ',
  [RENTAL_COURT_TYPE.GLASS]: 'グラス',
  [RENTAL_COURT_TYPE.CARPET]: 'カーペット',
};

export const RENTAL_COURT_ENVIRONMENT = {
  INDOOR: 1,
  OUTDOOR: 2,
};

export const RENTAL_COURT_ENVIRONMENT_TEXT = {
  [RENTAL_COURT_ENVIRONMENT.INDOOR]: 'インドア',
  [RENTAL_COURT_ENVIRONMENT.OUTDOOR]: 'アウトドア',
};

export const RENTAL_COURT_ENVIRONMENT_TYPE = {
  HITTING_WALL: 1,
  DOUBLE_SIDED: 2,
  AUTO: 3,
};

export const RENTAL_COURT_ENVIRONMENT_TYPE_TEXT = {
  [RENTAL_COURT_ENVIRONMENT_TYPE.HITTING_WALL]: '壁打ち',
  [RENTAL_COURT_ENVIRONMENT_TYPE.DOUBLE_SIDED]: '両面',
  [RENTAL_COURT_ENVIRONMENT_TYPE.AUTO]: 'オートテニス',
};

export const RENTAL_COURT_BUSINESS_TYPE = {
  NO_MANAGER: 1,
  HAVE_MANAGER: 2,
};

export const RENTAL_RESERVE_PAYMENT_STATUS = {
  UNPAID: 1,
  RECEIVED: 2,
  CANCELLED: 3,
};

export const RENTAL_RESERVE_SCHEDULE_STATUS = {
  BEFORE_USE: 1,
  IN_USE: 2,
  ALREADY_USED: 3,
  CANCELLED: 4,
};

export const TOURNAMENT_GROUP_FORMAT = {
  STAGED_ROUND: 1,
  QUALIFYING_ROUND: 2,
};

export const CANCELLATION_DEADLINE_TYPE = {
  DAY: 'day',
  TIME: 'time',
};

export const RENTAL_PRICE_SETTING_TYPE = {
  FLAT_RATE: 1,
  INDIVIDUAL: 2,
};

export const RENTAL_RESERVE_SCHEDULE_STATUS_TEXT = {
  [RENTAL_RESERVE_SCHEDULE_STATUS.BEFORE_USE]: '利用前',
  [RENTAL_RESERVE_SCHEDULE_STATUS.IN_USE]: '利用中',
  [RENTAL_RESERVE_SCHEDULE_STATUS.ALREADY_USED]: '利用済み',
  [RENTAL_RESERVE_SCHEDULE_STATUS.CANCELLED]: 'キャンセル済み',
};

export const RENTAL_PAYMENT_METHOD = {
  CREDIT_CARD: 2,
  CASH: 1,
  NONE: 3,
};

export const BANK_ACCOUNT_INFO_TYPE = {
  ZENGIN: 1,
  GMO: 2,
};

export const PLAN_PAYMENT_METHOD_TEXT = {
  [PLAN_PAYMENT_METHOD.BANK_ACCOUNT_TRANSFER]: '口座振替（GMO）',
  [PLAN_PAYMENT_METHOD.CREDIT_CARD]: 'クレジットカード（GMO）',
  [PLAN_PAYMENT_METHOD.GROUP_TOTAL]: 'まとめて支払い',
  [PLAN_PAYMENT_METHOD.ZENGIN_DATA]: '口座振替（全銀）',
  [PLAN_PAYMENT_METHOD.CASH]: '窓口精算',
  0: '未設定',
};
